import { render, staticRenderFns } from "./logsTable.vue?vue&type=template&id=82810250&scoped=true"
import script from "./logsTable.vue?vue&type=script&lang=js"
export * from "./logsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82810250",
  null
  
)

export default component.exports